import { render, staticRenderFns } from "./GDataTableRemote.vue?vue&type=template&id=5694251f&scoped=true&"
import script from "./GDataTableRemote.vue?vue&type=script&lang=js&"
export * from "./GDataTableRemote.vue?vue&type=script&lang=js&"
import style0 from "./GDataTableRemote.vue?vue&type=style&index=0&id=5694251f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5694251f",
  null
  
)

export default component.exports